// API paths
const createRequest = apiBase ? (apiBase + "/create-request") : null;
const myESIMAPI = apiBase ? (apiBase + "/esims") : null;

// Utility functions
function openContactSuccessPopup() {
  document.getElementById('contact_success_popup')?.classList.remove('hidden');
  document.body.style.overflow = 'hidden';
}

//  Close Auth Popup
function closeContactSuccessPopup() {
  document.getElementById('contact_success_popup')?.classList.add('hidden');
  document.body.style.overflow = 'auto';
}

function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function showError(input, message) {
  clearError(input);
  const error = document.createElement('div');
  error.className = 'field_error';
  error.textContent = message;
  input.parentNode.appendChild(error);
}

function clearError(input) {
  const existing = input.parentNode.querySelector('.field_error');
  if (existing) existing.remove();
}

function clearAllErrors() {
  document.querySelectorAll('.field_error').forEach(el => el.textContent);
}

function showFormSuccessMessage(message) {
  const successEl = document.querySelector('#success_contect_us');
  const errorEl = document.querySelector('#error_contact_us');
  if (successEl) successEl.textContent = message;
  if (errorEl) errorEl.textContent = '';
}

function showFormErrorMessage(message) {
  const successEl = document.querySelector('#success_contect_us');
  const errorEl = document.querySelector('#error_contact_us');
  if (errorEl) errorEl.textContent = message;
  if (successEl) successEl.textContent = '';
}

function clearFormMessages() {
  const successEl = document.querySelector('#success_contect_us');
  const errorEl = document.querySelector('#error_contact_us');
  if (successEl) successEl.textContent = '';
  if (errorEl) errorEl.textContent = '';
}

// Get eSIM and plan data
const getMyESIMData = async () => {
  try {
    const gbToken = await updateGBToken();
    const response = await fetch(myESIMAPI, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${gbToken}`
      }
    });

    if (!response.ok) {
      let errorDetail;
      try {
        errorDetail = await response.json();
      } catch {
        errorDetail = await response.text();
      }
      console.error("Error in esimsAPI: Network or API failure", errorDetail);
      return null;
    }

    const result = await response.json();
    let esimIList = [];

    result.forEach(esims => {
      esimIList.push(esims);
    });

    return { esimIList };
  } catch (error) {
    console.error("Error in esimsAPI: Exception thrown", error);
    return null;
  }
};
function formatDateOnContect(isoDateString) {
  const date = new Date(isoDateString);
  const options = { day: 'numeric', month: 'short', year: 'numeric' };
  return date.toLocaleDateString('en-GB', options);
}
function getSelectedEsimId(){
  const esimDiv = document.querySelector('#data_esim_id');
  const dataEsimId = esimDiv?.getAttribute('data-esim_id');
  console.log('dataEsim--> plan', dataEsimId);
  return dataEsimId
}

// =======================
// Utility: Validate query params
// =======================
function getQueryParamsWithValidation() {
  const params = new URLSearchParams(window.location.search);

  const esimId = params.get('esimId');
  const planId = params.get('planId');

  // // Basic validation: check if values exist and match expected patterns
  // const isValidEsimId = esimId && /^[a-f0-9]{24}$/i.test(esimId);
  // const isValidplanId = planId && /^[a-f0-9]{24}$/i.test(planId);

  if (!esimId || !planId) {
    console.error('Invalid or missing query parameters.');
    return null;
  }

  return { esimId, planId };
}
// Main logic
document.addEventListener('DOMContentLoaded', async () => {
    const form = document.getElementById('ContactForm');
    if (!form) return;
    let esimDataDisplay;
    let dataDisplay;
    let planDropDown;
    let dropdownContent;
    let dropdownBox;
    // Form fields
    const fullName = document.getElementById('ContactForm-full-name');
    const email = document.getElementById('ContactForm-email');
    const deviceInfo = document.getElementById('ContactForm-device-information');
    const message = document.getElementById('ContactForm-message');
    const countryCodeSelect = form.querySelector('select[name="contact[Country Code]"]');
    const mobileNumberInput = form.querySelector('input[type="tel"]');
    // const planSelect = document.getElementById('ContactForm-select-plan-support');
    // const planDropDown = document.getElementById('plan_drop_down');
    const esimSelect = document.getElementById('ContactForm-select-esim-support');
    const params = new URLSearchParams(window.location.search);

    // Real-time error clearing
    [fullName, email, mobileNumberInput, message].forEach(field => {
        if (field) {
            field.addEventListener('input', () => clearError(field));
        }
    });

    // Remove error in real time when user selects a country code
    countryCodeSelect.addEventListener('change', () => {
        if (countryCodeSelect.value.trim()) {
            document.getElementById('contact_mobile_error').textContent = '';

        }
    });
    // Name validation
    fullName.addEventListener('input', function() {
        this.value = this.value
            .replace(/[^a-zA-ZÀ-ÿ' -]/g, '') // only valid name chars
            .replace(/\s{2,}/g, ' ')
            .trimStart();

        if (this.value.length > 64) {
            showError(fullName, translations.error_full_name_mex);
        }
    });
    // Mobile number validation
    mobileNumberInput.addEventListener('input', function() {
        this.value = this.value.replace(/\D/g, ''); // remove non-digits
        document.getElementById('contact_mobile_error').textContent = "";
        if (this.value.length < 5) {
            document.getElementById('contact_mobile_error').textContent = translations.error_mobile_1
        }
    });
    // this is for Login user
    if (window.customerData.email) {
        // this is for need support esim dropdown
        const esimDropDown = document.getElementById("esim_drop_down");
        esimDataDisplay = document.getElementById("esim_data_dropdown");
        let esimEmptyDropdown = document.getElementById("esim_empty_dropdown");
        const esimDropdownContent = document.getElementById("esim_dropdown_content");
        const esimDropdownBox = document.getElementById("esim_dropdown_box");
        let esimClearAllBtn = document.getElementById("esim_clear_all_selection");
        const esimPlansMessage = document.getElementById("esim_plans_message");
        const esimEmptyMessage = document.getElementById("empty_plan_list");

        // need support Plan dropdown
        planDropDown = document.getElementById("plan_drop_down");
        dataDisplay = document.querySelector("#plan_data_dropdown");

        const emptyDropdown = document.querySelector("#plan_empty_dropdown");
        emptyDropdown.setAttribute("disabled", "");

        dropdownContent = document.querySelector("#plan_dropdown_content");
        dropdownBox = document.querySelector("#plan_dropdown_box");
        let clearAllBtn = dropdownContent.querySelector("#plan_clear_all_selection");
        const planEmptyMessage = document.getElementById("empty_plan_list_plans");

        // Real-time error clearing
        [deviceInfo].forEach((field) => {
            if (field) {
                field.addEventListener("input", () => clearError(field));
            }
        });
        if (countryCodeSelect)
            countryCodeSelect.addEventListener("change", () =>
                clearError(countryCodeSelect)
            );

        // Load plans and eSIMs if customerId exists
        const customerDiv = document.querySelector(".field_row[data-customer]");
        if (customerDiv) {
            const customerId = customerDiv.getAttribute("data-customer");
            if (customerId) {
                const esimData = await getMyESIMData();
                let plansList = [];
                if (!esimData) return;

                // Toggle dropdown visibility on click
                esimEmptyDropdown.addEventListener("click", () => {
                    esimDropdownContent.classList.toggle("hidden");
                });

                function clearSelectedEsim() {
                    esimDataDisplay.innerHTML = `
                      <div class="content_row">
                        <div class="con_rl">
                          <div></div><div></div>
                        </div>
                        <div class="con_rr">
                          <div></div><div></div>				
                        </div>
                      </div>
                    `;
                    const allOptions = esimDropDown.querySelectorAll(".content_row");
                    allOptions.forEach((opt) => opt.classList.remove("active_row"));
                    esimDropdownContent.classList.add("hidden");
                    esimDropdownBox.classList.remove("value_selected");
                }

                // Populate the dropdown with eSIMs
                // Populate the dropdown with eSIMs
                 //  Read esimId from query string (e.g. ?esimId=12345)
                    const queryEsimId = params.get("esimId");

                function populateEsimDropdown() {
                    esimDropDown.innerHTML = "";

                    if (!esimData.esimIList || esimData.esimIList.length === 0) {
                        esimPlansMessage.classList.add("hidden");
                        esimEmptyMessage.classList.remove("hidden");
                        return;
                    } else {
                        esimPlansMessage.classList.remove("hidden");
                        esimEmptyMessage.classList.add("hidden");
                    }

                   

                    esimData.esimIList.forEach((item) => {
                        const option = document.createElement("div");
                        option.className = "content_row";
                        option.innerHTML = `
                          <div class="con_rl">
                            <div>${item.name}</div>
                            <div>${translations.iccid} ${item.iccid}</div>
                          </div>
                          <div class="con_rr hidden">
                            <div>${translations.purchasedOn} ${formatDateOnContect(item.purchaseDate)}</div>
                            <div>${translations.status} <span class="first_letr_caps">${item.eSimState}</span></div>
                          </div>
                        `;

                        option.addEventListener("click", () => selectEsimOption(option, item));
                        esimDropDown.appendChild(option);

                        //  Auto-select if esimId matches query
                        if (queryEsimId && item.esimId === queryEsimId) {
                            selectEsimOption(option, item);
                        }
                    });
                }

                // Extracted selection logic so we can reuse it
                function selectEsimOption(option, item) {
                    emptyDropdown.removeAttribute("disabled");
                    clearPlanSelected();

                    const allOptions = esimDropDown.querySelectorAll(".content_row");
                    allOptions.forEach((opt) => opt.classList.remove("active_row"));

                    option.classList.add("active_row");

                    esimDataDisplay.innerHTML = `
                      <div class="content_row">
                        <div class="con_rl">
                          <div id="data_esim_id" data-esim_id="${item.esimId}">${item.name}</div>
                          <div>${translations.iccid} ${item.iccid}</div>
                        </div>
                        <div class="con_rr hidden">
                          <div>${translations.purchasedOn} ${formatDateOnContect(item.purchaseDate)}</div>
                          <div>${translations.status} <span class="first_letr_caps">${item.eSimState}</span></div>
                        </div>
                      </div>
                    `;

                    esimDropdownBox.classList.add("value_selected");
                    esimDropdownContent.classList.add("hidden");
                }

                // Clear All for eSIM
                esimClearAllBtn.addEventListener("click", () => {
                    emptyDropdown.setAttribute("disabled", "");
                    clearSelectedEsim();
                    clearPlanSelected();
                });

                // Initialize eSIMs
                populateEsimDropdown();

                //-------------  Plan dropdown functionality starts      
                // need support Plan dropdown
                function getEsimPlans() {
                  plansList = [];
                  esimData.esimIList.forEach((esims) => {
                    if (
                      esims.subscriptions &&
                      esims.subscriptions.length > 0 &&
                      esims.esimId == getSelectedEsimId()
                    ) {
                      esims.subscriptions.forEach((plan) => plansList.push(plan));
                    }
                  });

                  populateDropdown();
                  if (!getSelectedEsimId()) {
                    console.log("First select the esim");
                    emptyDropdown.setAttribute("disabled", "");
                    return false;
                  }
                  dropdownContent.classList.toggle("hidden");
                }

                // on click on select plan 
                emptyDropdown.addEventListener("click", () => {
                  getEsimPlans();
                  // dropdownContent.classList.add("hidden");                    
                });

                function clearPlanSelected() {
                  dataDisplay.innerHTML = "";
                  const allOptions = planDropDown.querySelectorAll(".content_row");
                  allOptions.forEach((opt) => opt.classList.remove("active_row"));
                  dropdownContent.classList.add("hidden");
                  dropdownBox.classList.remove("value_selected");
                }

                // Populate the Plan dropdown
                // Read planId from query string (?planId=12345)
                const queryPlanId = params.get("planId");

               function populateAndAutoSelectPlans(esims) {
                // Reset dropdown
                planDropDown.innerHTML = "";
                plansList = [];

                esimData.esimIList.forEach((esims) => {
                  esims.subscriptions.forEach((plan) => plansList.push(plan));
                });

                // Show empty message if no plans
                if (!plansList || plansList.length === 0) {
                  if (planEmptyMessage) planEmptyMessage.classList.remove("hidden");
                  return;
                } else {
                  if (planEmptyMessage) planEmptyMessage.classList.add("hidden");
                }

                // Render plans
                plansList.forEach((item) => {
                  const option = document.createElement("div");
                  option.className = "content_row";
                  option.innerHTML = `
                    <div class="con_rl">
                      <div>${item.name}</div>
                    </div>
                    <div class="con_rr">
                      <div>${translations.purchasedOn} ${formatDateOnContect(item.purchaseDate)}</div>
                      <div>${translations.status} <span class="first_letr_caps">${item.status}</span></div>
                    </div>
                  `;

                  planDropDown.appendChild(option);

                  //Auto-select if planId from query matches
                  if (queryPlanId && String(item._id) === String(queryPlanId)) {
                    console.log("auto select plan:", item._id);
                    selectPlanOption(option, item);
                  }
                });
              } 

              // called this for auto select is planId on the URL
                populateAndAutoSelectPlans()
                function populateDropdown() {
                  // console.log('--populateDropdown---');
                  planDropDown.innerHTML = "";

                  if (!plansList || plansList.length === 0) {
                    if (planEmptyMessage) planEmptyMessage.classList.remove("hidden");
                    return;
                  } else {
                    if (planEmptyMessage) planEmptyMessage.classList.add("hidden");
                  }

                  // selected plan id 
                  const planDiv = document.querySelector('#data_plan_id');
                  const selectedPlanId = planDiv?.getAttribute('data-plan_id');

                  plansList.forEach((item) => {
                    const option = document.createElement("div");
                    option.className = "content_row";

                    let countryMapping = {};

                    try {
                      if (typeof window.countryMapping === 'string') {
                        // Clean the escaped characters and Ruby-style syntax
                        let cleaned = window.countryMapping
                          .replace(/&quot;/g, '"')   // convert HTML quotes
                          .replace(/&gt;/g, '>')    // convert greater-than
                          .replace(/&lt;/g, '<')    // convert less-than
                          .replace(/=>/g, ':');     // convert Ruby => to JSON colon

                        // Fix missing quotes around keys (e.g. AFG: → "AFG":)
                        cleaned = cleaned.replace(/([{,]\s*)([A-Z0-9_]{2,5})\s*:/g, '$1"$2":');

                        countryMapping = JSON.parse(cleaned);
                      } else if (typeof window.countryMapping === 'object' && window.countryMapping !== null) {
                        parsedMapping = window.countryMapping;
                      } else {
                        console.warn("window.countryMapping is empty or invalid");
                      }
                    } catch (err) {
                      console.error("Failed to parse countryMapping:", err);
                      countryMapping = {};
                    }

                  // const countryParsedName = countryMapping[sub.planData.iso3code] || sub.country;
                    let countryParsedName = null;
                    if(item.planData && item.planData.supportedRegion){
                      let regexRegionName = item.planData.countryName.replace(/\s+/g, '');
                      countryParsedName = countryMapping[regexRegionName] || item.country
                    }else{
                      countryParsedName = countryMapping[item.planData.iso3code] || item.country;
                    }

                     const dataValue =
                        item.dataUsageAllowanceType === 'UNLIMITED'
                          ? item.dataUsageAllowanceType.charAt(0) + item.dataUsageAllowanceType.slice(1).toLowerCase()
                          : item.data;

                     const cycleText = formatCycle(item.cycle, item.cycleUnits);
                     const statusForClass = {
                        active: "Active",
                        upcoming: "Inactive",
                        expired: "Expired",
                        refunded: "Refunded",
                        terminated: "Terminated"
                      };
                      const statusMap = window.statusTranslations || {};
                      let planStatus = statusMap[item.status] || toTitleCase(item.status || "Unknown");

                    option.innerHTML = `
                      <div class="con_rl">
                        <div>${countryParsedName} ${dataValue} ${cycleText}</div>
                      </div>
                      <div class="con_rr">
                        <div>${translations.purchasedOn} ${formatDateOnContect(item.purchaseDate)}</div>
                        <div>${translations.status} <span class="first_letr_caps">${planStatus}</span></div>
                      </div>
                    `;

                    //  only add active_row if this plan matches selectedPlanId
                    console.log(selectedPlanId, item._id,'item._id');
                    if (selectedPlanId === item._id) {
                      option.classList.add("active_row");
                    }

                    option.addEventListener("click", () => {
                      // remove active_row from all others first
                      const allOptions = planDropDown.querySelectorAll(".content_row");
                      allOptions.forEach(opt => opt.classList.remove("active_row"));

                      // set this one active
                      option.classList.add("active_row");
                      selectPlanOption(option, item);
                      // console.log('click select-----');
                    });

                    planDropDown.appendChild(option);
                  });
                }

                // Extracted selection logic so it works for both click & preselect
                function selectPlanOption(option, item) {
                    const allOptions = planDropDown.querySelectorAll(".content_row");
                    allOptions.forEach((opt) => opt.classList.remove("active_row"));

                    option.classList.add("active_row");
                        let countryMapping = {};

                    try {
                      if (typeof window.countryMapping === 'string') {
                        // Clean the escaped characters and Ruby-style syntax
                        let cleaned = window.countryMapping
                          .replace(/&quot;/g, '"')   // convert HTML quotes
                          .replace(/&gt;/g, '>')    // convert greater-than
                          .replace(/&lt;/g, '<')    // convert less-than
                          .replace(/=>/g, ':');     // convert Ruby => to JSON colon

                        // Fix missing quotes around keys (e.g. AFG: → "AFG":)
                        cleaned = cleaned.replace(/([{,]\s*)([A-Z0-9_]{2,5})\s*:/g, '$1"$2":');

                        countryMapping = JSON.parse(cleaned);
                      } else if (typeof window.countryMapping === 'object' && window.countryMapping !== null) {
                        parsedMapping = window.countryMapping;
                      } else {
                        console.warn("window.countryMapping is empty or invalid");
                      }
                    } catch (err) {
                      console.error("Failed to parse countryMapping:", err);
                      countryMapping = {};
                    }

                  // const countryParsedName = countryMapping[sub.planData.iso3code] || sub.country;
                    let countryParsedName = null;
                    if(item.planData && item.planData.supportedRegion){
                      let regexRegionName = item.planData.countryName.replace(/\s+/g, '');
                      countryParsedName = countryMapping[regexRegionName] || item.country
                    }else{
                      countryParsedName = countryMapping[item.planData.iso3code] || item.country;
                    }

                     const dataValue =
                        item.dataUsageAllowanceType === 'UNLIMITED'
                          ? item.dataUsageAllowanceType.charAt(0) + item.dataUsageAllowanceType.slice(1).toLowerCase()
                          : item.data;

                     const cycleText = formatCycle(item.cycle, item.cycleUnits);

                     const statusForClass = {
                        active: "Active",
                        upcoming: "Inactive",
                        expired: "Expired",
                        refunded: "Refunded",
                        terminated: "Terminated"
                      };
                      const statusMap = window.statusTranslations || {};
                      let planStatus = statusMap[item.status] || toTitleCase(item.status || "Unknown");

                    dataDisplay.innerHTML = `
                      <div class="content_row">
                        <div class="con_rl">
                          <div id="data_plan_id" data-plan_id="${item._id}">${countryParsedName} ${dataValue} ${cycleText}</div>
                        </div>
                        <div class="con_rr">
                          <div>${translations.purchasedOn} ${formatDateOnContect(item.purchaseDate)}</div>
                          <div>${translations.status} <span class="first_letr_caps">${planStatus}</span></div>
                        </div>
                      </div>
                    `;

                    dropdownContent.classList.add("hidden");
                    dropdownBox.classList.add("value_selected");
                }

                // In populateEsimDropdown, after auto-selecting esim:
                
                // Clear All for Plans
                clearAllBtn.addEventListener("click", () => {
                    clearPlanSelected();
                });

            }
        }
    }

    // Handle form submission
    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        clearAllErrors();
        document.getElementById('contact_mobile_error').textContent = '';

        clearFormMessages();
        const planDiv = document.querySelector('#data_plan_id');
        const dataPlanId = planDiv?.getAttribute('data-plan_id');
        console.log('dataPlan-->', dataPlanId);

        let hasErrors = false;

        if (!fullName || !email || !message || !mobileNumberInput) {
            console.error('Required fields missing in DOM!');
            // showFormErrorMessage('Form is not properly loaded. Please refresh the page.');
            return;
        }

        if (!fullName.value.trim()) {
            showError(fullName, translations.error_full_name);
            hasErrors = true;
        }
        if (fullName.value.length > 64) {
            showError(fullName, translations.error_full_name_mex);
            hasErrors = true;
        }

        if (!email.value.trim()) {
            showError(email, translations.error_email_1);
            hasErrors = true;
        } else if (!isValidEmail(email.value.trim())) {
            showError(email, translations.error_email_2);
            hasErrors = true;
        }

        const mobileValue = mobileNumberInput.value.trim();
        const countryCodeValue = countryCodeSelect.value.trim();
        // Rule 1: If mobile number is filled, country code is required
        if (mobileValue && !countryCodeValue) {
            document.getElementById('contact_mobile_error').textContent = translations.error_country_code_required;
            hasErrors = true;
        }

        // Rule 2: Mobile number must be at least 5 digits if provided
        if (mobileValue.length > 0 && mobileValue.length < 5) {
            document.getElementById('contact_mobile_error').textContent = translations.error_mobile_1;
            hasErrors = true;
        }

        if (!message.value.trim()) {
            showError(message, translations.error_mess_text);
            hasErrors = true;
        }

        if (hasErrors) return;
        const formData = new FormData();

        const payload = {
            customerId: window.customerData ? window.customerData.customerId : null,
            name: fullName.value.trim(),
            email: email.value.trim(),
            deviceInfo: deviceInfo?.value.trim() || '',
            message: message.value.trim(),
            countryCode: countryCodeSelect?.value.trim() || '',
            number: mobileNumberInput?.value.trim() || '',
            subscriptionId: dataPlanId || '',
            esimId: getSelectedEsimId() || ''
        };

        console.log('Form data to send:', payload);
        for (const key in payload) {
            if (payload[key] !== undefined && payload[key] !== null) {
                formData.append(key, payload[key]);
            }
        }

        try {
            const gbToken = window.customerData?.email ? await updateGBToken() : null;
            const response = await fetch(createRequest, {
                method: 'POST',
                headers: gbToken ? {
                    'Authorization': `Bearer ${gbToken}`
                } : {},
                body: formData
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
              //  console.log("error data message from contact us...",errorData.message);
              if(response.status === 400){
                const errorMessage = translations.error_email_vrfy ? translations.error_email_vrfy : "Please fill a valid email address"
                showFormErrorMessage(errorMessage || "Please fill a valid email address");
                return
              }
                showFormErrorMessage(errorData.message || translations.api_404);
                return;
            }

            await response.json();
            contactUsSubmission(fullName.value.trim(), email.value.trim())
            form.reset();
            openContactSuccessPopup();

            if (window.customerData?.email) {
                clearSelectedEsim();
                dataDisplay.innerHTML = '';
                planDropDown.querySelectorAll('.content_row').forEach(opt => opt.classList.remove('active_row'));
                dropdownContent.classList.add('hidden');
                dropdownBox.classList.remove('value_selected');
                // remove query params from URL without reloading
                const url = window.location.origin + window.location.pathname;
                window.history.replaceState({}, document.title, url);
            }
        } catch (error) {
            console.error('Form submission error:', error);
            showFormErrorMessage(translations.contect_api_error);
        }
    });

});

  function formatCycle(count, unitFromApi) {
    if (!unitFromApi) return `${count}`;

    const unit = unitFromApi.toLowerCase();

    if (unit.startsWith('day')) {
      const label = window.esimsLanguages.days_txt || 'Days';
      return `${count} ${count === 1 ? label.replace(/s$/i, '') : label}`;
    }

    const unitMap = {
      month: 'month',
      months: 'months',
      year: 'year',
      years: 'years',
    };

    const normalized = unitMap[unit] || unit;
    return `${count} ${count === 1 ? normalized.replace(/s$/i, '') : normalized}`;
  }

  function toTitleCase(name) {
      if (name) {
        return name
          .toLowerCase()
          .split(' ')
          .filter(word => word.trim() !== '')
          .map(word => word[0].toUpperCase() + word.slice(1))
          .join(' ');
      } else {
        return null;
      }
}
